const AccountSettings = () => import(/* webpackChunkName: "vendor-account-settings" */ "@/views/AccountSettings.vue");
import { createRouter, createWebHistory } from "vue-router";
const Dashboard = () => import(/* webpackChunkName: "vendor-dashboard" */ "@/views/Dashboard.vue");
const Invoice = () => import(/* webpackChunkName: "vendor-invoice" */ "@/views/Invoice.vue");
const Message = () => import(/* webpackChunkName: "vendor-message" */ "@/views/Message.vue");
const change_password = () => import(/* webpackChunkName: "vendor-change-password" */ "@/views/change_password.vue");
const VirtualReality = () => import(/* webpackChunkName: "vendor-virtual-reality" */ "@/views/VirtualReality.vue");
const Profile = () => import(/* webpackChunkName: "vendor-profile" */ "@/views/Profile.vue");
const Rtl = () => import(/* webpackChunkName: "vendor-rtl" */ "@/views/Rtl.vue");
const SignIn = () => import(/* webpackChunkName: "vendor-sign-in" */ "@/views/SignIn.vue");
const forgot_password = () => import(/* webpackChunkName: "vendor-forgot-password" */ "@/views/forgot_password.vue");
const SignUp = () => import(/* webpackChunkName: "vendor-sign-up" */ "@/views/SignUp.vue");
const Signature = () => import(/* webpackChunkName: "vendor-signature" */ "@/views/Signature.vue");
const PaymentDetails = () => import(/* webpackChunkName: "vendor-payment-details" */ "@/views/PaymentDetails.vue");
const Enrollment = () => import(/* webpackChunkName: "vendor-enrollment" */ "@/views/Enrollment.vue");
const VendorForms = () => import(/* webpackChunkName: "vendor-vendor-forms" */ "@/views/VendorForms.vue");
const PayrollRates = () => import(/* webpackChunkName: "vendor-payroll-rates" */ "@/views/PayrollRates.vue");

const DeviceManagement = () => import(/* webpackChunkName: "vendor-device-management" */ "@/views/DeviceManagement.vue");
const routes = [
  { path: '/document-templates/:templateId', name: 'Personal Document Editor', component: () => import(/* webpackChunkName: "vendor-document-editor" */ '@/views/PortalDocumentEditor.vue'), props: route => ({ templateId: route.params.templateId, portal: 'vendor', backPath: '/vendor_form' }) },
  { path: "/device-management", name: "Device Management", component: DeviceManagement },
  { path: "/account-settings", name: "Settings", component: AccountSettings },
  {
    path: "/",
    name: "/",
    redirect: "/dashboard",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/Invoice",
    name: "Invoice",
    component: Invoice,
  },
  {
    path: "/Message",
    name: "Message",
    component: Message,
  },
  {
    path: "/virtual-reality",
    name: "Virtual Reality",
    component: VirtualReality,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/rtl-page",
    name: "Rtl",
    component: Rtl,
  },
  {
    path: "/sign-in",
    name: "Sign In",
    component: SignIn,
  },
  {
    path: "/sign-up",
    name: "Sign Up",
    component: SignUp,
  },
  {
    path: "/forgot_password",
    name: "forgot Password",
    component: forgot_password,
  },
  {
    path: "/change_password",
    name: "Change Password",
    component: change_password,
  },
  {
    path: "/signature",
    name: "Signature",
    component: Signature,
  },
  {
    path: "/paymentdetails",
    name: "Payment Dtails",
    component: PaymentDetails,
  },
  {
    path: "/payroll-rates",
    name: "Payroll Rates",
    component: PayrollRates,
  },
  {
    path: "/enrollment",
    name: "Enrollment",
    component: Enrollment,
  },
  {
    path: "/vendor_form",
    name: "Vendor Forms",
    component: VendorForms,
  },
  {
    path: "/payroll-rates",
    name: "Payroll Rates",
    component: PayrollRates,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem("token");
  const expiration = Number(localStorage.getItem("tokenExpiration"));
  if (["/sign-in", "/sign-up", "/forgot_password"].includes(to.path)) return next();
  if (!token || Date.now() >= expiration) return next("/sign-in");
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 10000);
  try {
    const response = await fetch(`${process.env.VUE_APP_BACKEND_DOMAIN}/api/vendor-devices/session`, {
      headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' }, signal: controller.signal, cache: 'no-store',
    });
    if (localStorage.getItem('token') !== token) return next(false);
    if ([401, 403].includes(response.status)) {
      localStorage.removeItem('token'); localStorage.removeItem('tokenExpiration');
      return next({ path: '/sign-in', query: { reason: 'session-expired' }, replace: true });
    }
    if (!response.ok) return next({ path: '/sign-in', query: { reason: 'verification-unavailable' }, replace: true });
    localStorage.setItem('tokenExpiration', Date.now() + 60 * 60 * 1000);
    next();
  } catch {
    if (localStorage.getItem('token') !== token) return next(false);
    next({ path: '/sign-in', query: { reason: 'verification-unavailable' }, replace: true });
  } finally { clearTimeout(timer); }
});

export default router;
